import React from 'react';
import { object } from 'prop-types';
import styled from 'styled-components';
import PhoenixTheme from '@airasia/phoenix-components/components/Theme';
import UniversalFooter from '@airasia/phoenix-widgets/widgets/UniversalFooter';

const UHFFooter = styled.div``;

const HotelFooter = props => {
  const { data } = props;
  const { components, footerBottomLinks, footerNotes, footerTopLinks } =
    data || {};
  return data ? (
    <UHFFooter>
      <PhoenixTheme>
        <UniversalFooter
          accessible
          background="primary"
          color="greyDark"
          data={{
            components,
            footerTopLinks,
            footerBottomLinks,
            footerNotes,
          }}
          fontSize="XSmall"
          viewport="desktop"
        />
      </PhoenixTheme>
    </UHFFooter>
  ) : (
    ''
  );
};

HotelFooter.propTypes = {
  data: object,
};

export default React.memo(HotelFooter);
